export const componentElements = [
  'My Profile',
  'UiConfig',
  "all",
  "order",
  "homepage",
  "common",
  "login",
  "notification",
  "dashboard",
  "sellina",
  "inventory",
  "survey",
  "pjp",
  "faq",
  "helpdesk",
  "outletMapping",
  "attendance",
  "profile",
  "stockReturn",
  "petRegistration",
  "outletActivity",
  "mustDoAction",
  "Baskets",
  "Login Page",
  "Catalogue",
  "Profile",
  "Complaint",
  "Cart",
  "Order Summary",
  "Order Tracking",
  "Baskets",
  "Manage Banner",
  "Admin Panel",
  "Report And Logs",
  "Common Component",
  "Generic Filters",
  "Manage Bucket",
  "commonPortal",
  "Smart Trigger",
  "Support",
  "Manage Basket",
  "Update Configuration",
  "Firebase Configuration",
  "Update Translation",
  "Manage Policies",
  "Manage Events",
  "Manage Update Access",
  "Master Data Management",
  "Division",
  "Import",
  "ValidationSupport",
  "Validate API",
  "User",
  "OutletDetails",
  "ProductDetails",
  "Blobkey",
  "Order Analytics",
  "Reports",
  "Manage Order",
  "Analytics Dashboard",
  "Master Data Reports",
  "Slow Queries",
  "ValidationDivision",
  "GenericModal",
  "Sidebar Options",
  "Manage Registry",
  "Manage Home Screen",
  "Existing Outlet Approval",
  "Outlet Approval",
  "Navbar Options",
  "Business Impact",
  "Integration Statistics",
  "LogInAndChangePassword",
  "ValidateOtp",
  "PasswordReset",
  "Analytics",
  "Language",
  "Schemes"
];

export const ActionsColumns = ["Update", "Delete"];

export type languageType = {
  code: string;
  language: string;
};

export type dataGridHeaderType = {
  headerName: string;
  mappedValue: string;
};

export type popUpType = {
  key?: string;
  name?: string
  EN?: string;
  HI?: string;
  HIE?: string;
  GU?: string;
  PA?: string;
  TA?: string;
  TE?: string;
  ML?: string;
  KN?: string;
  MR?: string;
  BN?: string;
  AS?: string;
  idList?: Record<string, string>;
  [key: string]: string | undefined | Record<string, string>;
}

export type updateRequestType = {
  translationKey: string | undefined;
  translationValue: string | Record<string, string> | undefined;
  translationName: string | undefined
  translationLanguage: string;
  component: string;
  description: string;
  activeStatusReason?: string;
};

export type translationResponseType = {
  createdBy: string;
  modifiedBy: string;
  creationTime: string;
  lastModifiedTime: string;
  lob: string;
  id: string;
  activeStatus: string;
  activeStatusReason: null | string;
  version: number;
  source: null | string;
  changes: any[];
  changed: boolean;
  extendedAttributes: null | any;
  translationKey: string;
  translationName: string;
  translationValue: string;
  component: string;
  translationLanguage: string;
  description: string;
  create: boolean;
};

export type languageToDataMapType = {
  [key: string]: translationResponseType;
};



export type batchType = {
  features: updateRequestType[];
}